import { useAuthModalStore } from "@/Store/useAuthModalStore";
import { Success } from "@/Utils/BaseUrl";
import Dialog from "@mui/material/Dialog";
import { XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import SellerInfoModal from "./SellerInfo";

export default function CommonModal() {
  const { statusOpen, statusMode, closeStatusModal } = useAuthModalStore();
  const params = new URLSearchParams(location.search);
  const redirect = params.get("redirect");
  const navigate = useNavigate();
  const { t } = useTranslation()
  return (
    <Dialog
      open={statusOpen}
      onClose={() => {
        closeStatusModal();
        if (redirect) {
          navigate(redirect);
        }
      }}
      PaperProps={{
        sx: {
          width: "900px",
          maxWidth: { xs: "90%", sm: "600px", md: "800px", lg: "500px" },
          height: statusMode === "sellerInfo" ? "100%" : "300px",
          display: "flex",
          flexDirection: "row",
          backgroundColor: "transparent",
          overflow: "hidden",
          borderRadius: "10px",
          boxShadow: "0px 0px 40px rgba(0,0,0,0.5)",
        },
      }}
    >
      <div className="flex w-full h-full items-center justify-center flex-col gap-4 bg-white">
        {statusMode === "success" && (
          <>
            <div className="w-full flex flex-col items-center justify-center">
              <img src={Success} alt="" className="w-[50%] h-[50%] py-10" />
              <h3 className="text-2xl font-semibold text-[#0C0A20]">
                {t("Welcome aboard!")}
              </h3>
              <p className="text-center text-[#6D6C79] font-inter text-sm font-medium leading-5 tracking-[-0.12px]">
                {t("Your account is ready. Start exploring exclusive deals, discovering top brands,")} <br /> {t("and enjoying a shopping experience tailored just for you.")}
              </p>
            </div>
          </>
        )}
        {statusMode === "failed" && (
          <>
            <XCircle size={90} className="text-red-500" />
            <h2 className="text-red-400 text-2xl font-semibold">{("Failed!")}</h2>
          </>
        )}
        {statusMode === "sellerInfo" && <SellerInfoModal />}
        <div className="flex items-end px-6 py-3 h-[20%] justify-between w-full text-xs text-[#8E8E8E]"></div>
      </div>
    </Dialog>
  );
}
